import { render, staticRenderFns } from "./App.vue?vue&type=template&id=15749a4a"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=15749a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@2.7.16_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vu_qgmhcv2zwyplqohcijlq2qcl3q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports